const TABLE_FIELDS = [
  "involvedTeam",
  "linkedOrganization",
  "expectedGoals",
  "resultIndicators",
  "achievedResults",
];

const parseRowsSafe = (value) => {
  if (Array.isArray(value)) return value.filter((row) => row && typeof row === "object");
  if (value === null || value === undefined || value === "") return [];
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.filter((row) => row && typeof row === "object");
    } catch {
      return [{ description: trimmed }];
    }
  }
  return [];
};

export const normalizeImportedProjectDraft = (raw = {}, baseForm = {}, settings = {}) => {
  const merged = { ...(baseForm || {}), ...(raw || {}) };
  const normalized = {
    ...merged,
    tags: Array.isArray(merged.tags) ? merged.tags.filter(Boolean).join(", ") : String(merged.tags || ""),
    shortDescription: String(merged.shortDescription || "").replace(/\s+/g, " ").trim().slice(0, 400),
    initialBudgetItems:
      Array.isArray(merged.initialBudgetItems) && merged.initialBudgetItems.length
        ? merged.initialBudgetItems
        : (Array.isArray(baseForm?.initialBudgetItems) && baseForm.initialBudgetItems.length
          ? baseForm.initialBudgetItems
          : [{ itemName: "", quantity: "1", unitValue: "", category: "", description: "" }]),
    fieldConfig: { ...(baseForm?.fieldConfig || {}), ...(merged.fieldConfig || {}) },
    reportColor: merged.reportColor || settings?.brandColors?.primary || "#7b68ee",
  };

  TABLE_FIELDS.forEach((field) => {
    normalized[field] = parseRowsSafe(merged[field]);
  });

  return normalized;
};

export const mergeImportedAiField = (draft, field, value, settings = {}) =>
  normalizeImportedProjectDraft({ ...draft, [field]: value }, draft, settings);

export const importedProjectTableFields = TABLE_FIELDS;
